import React, { useState } from 'react'
import Button from 'components/shared/Button'
import { InputField } from 'components/forms/reduxForm'
import strings from 'strings'
import AuthService from "../../../../tools/AuthService";
import CreditCost from 'components/shared/CreditCost'

const AllStatesSearchFields = (props) => {

    const { loading, handleAllStatesSearch, creditCosts } = props
    const { creditUsageEnabled } = AuthService.getClientFeatures()

    // form data
    const [businessName, setBusinessName] = useState('')

    const getEndIcon = () => {
        if (creditCosts){
            const costObj = creditCosts.find(cost => cost.requestType === 'SOS_ALL_STATES_SEARCH');
            return costObj ? costObj.creditCost : 0;
        }
        return 0;
    }

    return (
        <div className='sosAllStateFieldContainer'>
            <div className='d-flex'>
                <InputField
                    name='businessName'
                    label='Business Name'
                    required
                    id='businessNameAllStates'
                    onChange={(e) => setBusinessName(e.target.value)}
                />
            </div>
            <Button
                onClick={() => handleAllStatesSearch({ businessName })}
                loading={loading}
                id='perform-all-states-search-app'
                disabled={!businessName}
                endIcon={creditUsageEnabled && creditCosts ?
                    <CreditCost cost={getEndIcon()} /> : undefined}
            >
                {strings.SEARCH}
            </Button>
        </div>
    )
}

export default AllStatesSearchFields